/**
 * Store admin — order detail (Commerce, M3).
 * @see prototype/store/admin/all.html#orders-detail
 */
import { createFileRoute } from "@tanstack/react-router";
import { OrderDetailPage } from "../../../../../../features/store/orders/order-detail-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/orders/$orderId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  return <OrderDetailPage orderId={orderId} />;
}
